module.exports = __webpack_public_path__ + "static/media/menu-icon.fbe9f4d9.svg";